export default __webpack_public_path__ + "static/media/ic_mark.3a2e878b.svg";